import "./AndroidAppModal.css";

export default function AndroidAppModal({ isOpen, onClose }) {
    if (!isOpen) { return null; }

    return (
        <div className="android-modal-overlay">
            <div className="main-android-download-modal">

                {/* Close */}
                <button
                    type="button"
                    className="android-modal-close"
                    onClick={onClose}
                    aria-label="Close"
                >
                    <i className="fa-solid fa-xmark"></i>
                </button>

                {/* ================= LEFT SIDE ================= */}
                <div className="android-download-modal">
                    <div className="android-modal-visual">

                    {/* <div className="android-visual-circle android-circle-one"></div>
                    <div className="android-visual-circle android-circle-two"></div> */}

                    {/* Decorative Arrow */}
                    {/* <div className="android-curved-arrow">
                        <span></span>
                        <i className="fa-solid fa-location-arrow"></i>
                    </div> */}

                    {/* Phone */}
                    <div>
                        <img src="/images/drone-app-phone.webp" className="phone-image" alt="" />
                    </div>

                    {/* Android badge */}
                    {/* <div className="android-badge">
                        <i className="fa-brands fa-android"></i>
                    </div> */}
                </div>


                {/* ================= RIGHT SIDE ================= */}
                <div className="android-modal-content">

                    <div className="android-app-eyebrow">
                        DOWNLOAD OUR
                    </div>

                    <h2>
                        Mobile App
                    </h2>

                    <div className="android-title-line"></div>

                    <p className="android-app-description">
                        Get the best drone experience on your Android device.
                        Download and install our app for seamless control and
                        real-time access.
                    </p>


                    {/* Features */}
                    <div className="android-app-features">

                        <div className="android-app-feature">
                            <div className="android-feature-icon">
                                <i className="fa-solid fa-bolt"></i>
                            </div>

                            <div className="android-feature-text">
                                <strong>Fast &amp; Smooth</strong>
                                <span>Performance</span>
                            </div>
                        </div>


                        <div className="android-feature-divider"></div>


                        <div className="android-app-feature">
                            <div className="android-feature-icon">
                                <i className="fa-solid fa-shield-halved"></i>
                            </div>

                            <div className="android-feature-text">
                                <strong>Secure &amp;</strong>
                                <span>Reliable</span>
                            </div>
                        </div>


                        <div className="android-feature-divider"></div>


                        <div className="android-app-feature">
                            <div className="android-feature-icon">
                                <i className="fa-solid fa-mobile-screen-button"></i>
                            </div>

                            <div className="android-feature-text">
                                <strong>Optimized for</strong>
                                <span>Android</span>
                            </div>
                        </div>

                    </div>
                </div>
                </div>

                <div className="android-app-actions">

                        <button
                            type="button"
                            className="android-continue-btn"
                            onClick={onClose}
                        >
                            <span className="android-continue-icon">
                                <i className="fa-regular fa-compass"></i>
                            </span>

                            <span>Continue Browsing</span>
                        </button>


                        <a
                            href="https://demo.dronestreamx.com/app/dronestreamx.apk"
                            className="android-download-btn"
                            download
                        >
                            <span className="android-download-icon">
                                <i className="fa-solid fa-download"></i>
                            </span>

                            <span>Download App</span>

                            <i className="fa-solid fa-arrow-right android-download-arrow"></i>
                        </a>

                    </div>

            </div>
        </div>
    );
}
